import Image from 'next/image'
import styled from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper } from '@theme'

const MAX_WIDTH_CONTAINER = 996

export const PageContent = styled(NormalizedWrapper)`
  max-width: ${MAX_WIDTH_CONTAINER}px;
  width: 100%;
  ${({ theme }) => theme.below.laptopM`
     padding: 0 ${theme.spaces[4]}px;
  `}

  ${({ theme }) => theme.below.tablet`
     margin-top: ${theme.spaces[5]}px;
  `}
`

export const ResponsiveImage = styled(ImageWithPlaceholder)`
  height: unset;
  object-fit: contain;
  position: relative;
  width: 100%;
`
export const DevelopingSolutionImage = styled(ResponsiveImage)`
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
`
export const TopRightHexagon = styled(Image)`
  position: absolute;
  right: 0px;
  top: 0;
  width: 200px;

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`
